import React from 'react';
import { Route, Switch } from 'react-router';

import { Header, Content } from '@crm-package/layouts';

import { ContentWrapper } from './styled';
import { WithdrawalForm } from './WithdrawalForm';

export const WithdrawalLayout: React.FC<{ name: string }> = ({
  name,
  children,
}) => (
  <>
    <Header>
      <ContentWrapper>{name}</ContentWrapper>
    </Header>
    <ContentWrapper>
      <Content>
        <Switch>
          <Route
            path="/"
            render={() => (
              <WithdrawalForm name={name}>{children}</WithdrawalForm>
            )}
          />
        </Switch>
      </Content>
    </ContentWrapper>
  </>
);
